import React, { useState, useEffect, useRef } from 'react';
import '../../../../Utility/Public/css/common.scss';
import '../Assets/css/homedoc.scss';
import '../Assets/css/homeresponsivedoc.scss';
import CustomInput from '../../../../Utility/Components/CustomInput';
import ErrorBoundary from '../../../../Utility/Components/ErrorBoundary';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import CommonDateTimePicker from '../../../../Utility/Components/CommonDateTimePicker';
import AutosuggestComponent from '../../../../Utility/Components/AutosuggestComponent';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { filterPanelList } from '../Controller/HomeController';
import { loaderStateTrue, loaderStateFalse, selectChooseBranch, userSearchData, roleWisePermission } from '../../../../Actions/AllAction';
import { setToken, setUserCredentials, logOutApp } from '../../../../../src/GlobalModules/Login/Actions/LoginAction';
import MultiRangeSlider from "../../../../Utility/Components/MultiRangeSlider";
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
import SkeletonThemeFilterContent from '../../../../Utility/Components/SkeletonThemeFilterContent'
import Utility from '../../../../Utility/Utility';
function FilterPanel(props) {
    const [isViewportBottom, setIsViewportBottom] = useState(false);
    const [filterDataFromApi, setFilterDataFromApi] = useState({});
    const [isFilterDataChanged, setIsFilterDataChanged] = useState(false);
    const [apiCallFilterFinish, setApiCallFilterFinish] = useState(false)
    const [budgetRange, setBudgetRange] = useState({ min: 0, max: 0 });
    const [budgetValue, setBudgetValue] = useState({
        min: props.userSearchDataFromReducer?.filterData?.budget_min ? props.userSearchDataFromReducer.filterData.budget_min : 0,
        max: props.userSearchDataFromReducer?.filterData?.budget_max ? props.userSearchDataFromReducer.filterData.budget_max : 0
    });
    const [filterPanelData, setFilterPanelData] = useState({
        budget_min: props.userSearchDataFromReducer?.filterData?.budget_min ? props.userSearchDataFromReducer.filterData.budget_min : 0,
        budget_max: props.userSearchDataFromReducer?.filterData?.budget_max ? props.userSearchDataFromReducer.filterData.budget_max : 0,
        property_type: props.userSearchDataFromReducer?.filterData?.property_type ? props.userSearchDataFromReducer.filterData.property_type : [],
        property_rating: props.userSearchDataFromReducer?.filterData?.property_rating ? props.userSearchDataFromReducer.filterData.property_rating : [],
        amenities: props.userSearchDataFromReducer?.filterData?.amenities ? props.userSearchDataFromReducer.filterData.amenities : [],
        meals: props.userSearchDataFromReducer?.filterData?.meals ? props.userSearchDataFromReducer.filterData.meals : []
    })
    const [mealList, setMealList] = useState(["Breakfast", "Lunch", "Dinner"]);
    const [propertyRatingList, setPropertyRatingList] = useState(["1 star", "2 stars", "3 stars", "4 stars", "5 stars"]);


    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;
            const scrollTop = window.scrollY;
            if (scrollTop >= 1050) {
                setIsViewportBottom(true);
            } else {
                setIsViewportBottom(false);
            }
            if (scrollPosition + windowHeight > documentHeight - 600) {

                setIsViewportBottom(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };


    }, []);

    //initially fetch left filter panel data from api
    useEffect(() => {
        getFilterPanelList();
    }, [])

    // Sync local state with Redux when URL parameters are loaded
    useEffect(() => {
        // Only update local state if Redux has filter data
        if (props.userSearchDataFromReducer?.filterData) {
            // console.log('FilterPanel: Updating local state from Redux', props.userSearchDataFromReducer.filterData);
            
            // Update filterPanelData with the values from Redux
            setFilterPanelData({
                budget_min: props.userSearchDataFromReducer.filterData.budget_min !== undefined ? 
                    props.userSearchDataFromReducer.filterData.budget_min : filterPanelData.budget_min,
                budget_max: props.userSearchDataFromReducer.filterData.budget_max !== undefined ? 
                    props.userSearchDataFromReducer.filterData.budget_max : filterPanelData.budget_max,
                // Ensure property_type is always an array
                property_type: Array.isArray(props.userSearchDataFromReducer.filterData.property_type) ?
                    [...props.userSearchDataFromReducer.filterData.property_type] :
                    (props.userSearchDataFromReducer.filterData.property_type ? 
                        [props.userSearchDataFromReducer.filterData.property_type] : []),
                // Ensure property_rating is always an array
                property_rating: Array.isArray(props.userSearchDataFromReducer.filterData.property_rating) ?
                    [...props.userSearchDataFromReducer.filterData.property_rating] :
                    (props.userSearchDataFromReducer.filterData.property_rating ? 
                        [props.userSearchDataFromReducer.filterData.property_rating] : []),
                // Ensure amenities is always an array
                amenities: Array.isArray(props.userSearchDataFromReducer.filterData.amenities) ?
                    [...props.userSearchDataFromReducer.filterData.amenities] :
                    (props.userSearchDataFromReducer.filterData.amenities ? 
                        [props.userSearchDataFromReducer.filterData.amenities] : []),
                // Ensure meals is always an array
                meals: Array.isArray(props.userSearchDataFromReducer.filterData.meals) ?
                    [...props.userSearchDataFromReducer.filterData.meals] :
                    (props.userSearchDataFromReducer.filterData.meals ? 
                        [props.userSearchDataFromReducer.filterData.meals] : [])
            });
            
            // Also update the budget range UI
            if (props.userSearchDataFromReducer.filterData.budget_min !== undefined || 
                props.userSearchDataFromReducer.filterData.budget_max !== undefined) {
                setBudgetValue({
                    min: props.userSearchDataFromReducer.filterData.budget_min !== undefined ? 
                        props.userSearchDataFromReducer.filterData.budget_min : budgetValue.min,
                    max: props.userSearchDataFromReducer.filterData.budget_max !== undefined ? 
                        props.userSearchDataFromReducer.filterData.budget_max : budgetValue.max
                });
            }
        }
    }, [props.userSearchDataFromReducer?.filterData]);

    //fetch left filter panel data api
    const getFilterPanelList = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let data = {}
        setApiCallFilterFinish(false)
        setFilterDataFromApi([])
        filterPanelList(data).then((response) => {
            setFilterDataFromApi(response.data)
            setApiCallFilterFinish(true)
            props.filterApiSuccessCheckFn(true)
        }).catch((error) => {
            setApiCallFilterFinish(true)
        });
    }

    //set budget range input data
    useEffect(() => {
        setBudgetRange({ min: 0, max: filterDataFromApi.room_rate ? parseInt(filterDataFromApi.room_rate) : Infinity })
        setBudgetValue({
            min: props.userSearchDataFromReducer?.filterData?.budget_min ? props.userSearchDataFromReducer.filterData.budget_min : 0,
            max: props.userSearchDataFromReducer?.filterData?.budget_max ? props.userSearchDataFromReducer.filterData.budget_max : filterDataFromApi.room_rate ? parseInt(filterDataFromApi.room_rate) : 0
        });

    }, [filterDataFromApi])


    //property type list ui in filter panel
    const propertyTypeUi = () => {
        if (!filterDataFromApi || !filterDataFromApi.property_type) {
            return null;
        }
        let propertyType = filterDataFromApi.property_type;
        // Get property_type as an array to handle both single and multiple selections
        const propertyTypeArray = Array.isArray(filterPanelData.property_type) ? 
            filterPanelData.property_type : 
            (filterPanelData.property_type ? [filterPanelData.property_type] : []);
            
        let arry = [];
        if (propertyType.length > 0) {
            propertyType.map((val, idx) => {
                arry.push(
                    <li key={`checkbox_${idx}`}>
                        <label className="chkContainer"> {val.name}
                            <input type="checkbox"
                                value={val.name}
                                onChange={(e) => handlePropertyTypeCheckboxChange(e, val)}
                                checked={propertyTypeArray.includes(val.name)}
                            />
                            <span className="checkmark"></span>
                        </label>
                    </li>
                )
            })
        }
        return arry;
    }

    //property onchange handler - modified to allow only one selection at a time
    const handlePropertyTypeCheckboxChange = (event, val) => {
        const { checked } = event.target;
        
        if (checked) {
            // If this checkbox is checked, make it the only selected property type
            debounceDispatchPropertyTypeList([val.name]);
        } else {
            // If this checkbox is unchecked, clear the property type selection
            debounceDispatchPropertyTypeList([]);
        }
    };

    //debounce property onchange set filter panel data
    /*const debounceDispatchPropertyTypeList = Utility.debounce((value, checked) => {
        console.log("value===========",value)
        setFilterPanelData({
            ...filterPanelData,
            property_type: checked
                ? [...filterPanelData.property_type, value]
                : filterPanelData.property_type.filter((item) => item !== value)
        });
    }, 300);*/
    const debounceDispatchPropertyTypeList = Utility.debounce((propertyTypes) => {
        setFilterPanelData({
            ...filterPanelData,
            property_type: propertyTypes, // Now only contains a single value or empty array
            property_rating: [], // Reset property_rating when property_type changes (intended behavior)
            amenities: filterPanelData.amenities, // Preserve amenities values
            meals: filterPanelData.meals // Preserve meals values
        });
        setIsFilterDataChanged(true);
    }, 300);

    const shouldShowPropertyRating = () => {
        // Get the first property type from the array if it exists
        const propertyTypes = Array.isArray(filterPanelData.property_type) ? 
            filterPanelData.property_type : 
            (filterPanelData.property_type ? [filterPanelData.property_type] : []);
        
        if (propertyTypes.length === 0 || !filterDataFromApi?.property_type) return false;
        
        // Find the first property type that has star category
        const selectedName = propertyTypes[0];
        const found = filterDataFromApi.property_type.find(pt => pt.name === selectedName);
        return found?.is_star_category === true;
    };

    //property rating ui in left panel
    const propertyRatingUi = () => {
        let arry = [];
        if (propertyRatingList.length > 0) {
            propertyRatingList.map((val, idx) => {
                // Use local filterPanelData for checked state instead of props.userSearchDataFromReducer
                const propertyRatings = Array.isArray(filterPanelData.property_rating) ? 
                    filterPanelData.property_rating : 
                    (filterPanelData.property_rating ? [filterPanelData.property_rating] : []);
                    
                arry.push(
                    <li key={idx}>
                        <label className="chkContainer"> {val}
                            <input type="checkbox"
                                value={val}
                                onChange={handlePropertyRatingCheckboxChange}
                                checked={propertyRatings.includes(val)}
                            />
                            <span className="checkmark"></span>
                        </label>
                    </li>
                )
            })
        }
        return arry;
    }

    //proprty rating onchange event
    const handlePropertyRatingCheckboxChange = (event) => {
        const { value, checked } = event.target;
        debounceDispatchPropertyRatingList(value, checked);
    };

    //proprty rating set on filter panel after onchange 
    const debounceDispatchPropertyRatingList = Utility.debounce((value, checked) => {
        setFilterPanelData({
            ...filterPanelData,
            // Preserve property_type explicitly as mentioned in your memory to fix the issue where
            // checking/unchecking ratings would cause property_type to get unchecked
            property_type: filterPanelData.property_type,
            amenities: filterPanelData.amenities, // Preserve amenities
            meals: filterPanelData.meals, // Preserve meals
            property_rating: checked
                ? [...filterPanelData.property_rating, value]
                : filterPanelData.property_rating.filter((item) => item !== value)
        });
        setIsFilterDataChanged(true)
    }, 300);


    //aminity ui in left panel
    const amenitiesTypeUi = () => {
        if (!filterDataFromApi || !filterDataFromApi.amenities_type) {
            return null;
        }
        let amenitiesType = filterDataFromApi.amenities_type;
        
        // Use local filterPanelData state instead of Redux state for UI
        const amenitiesArray = Array.isArray(filterPanelData.amenities) ? 
            filterPanelData.amenities : 
            (filterPanelData.amenities ? [filterPanelData.amenities] : []);
            
        let arry = [];
        if (amenitiesType.length > 0) {
            amenitiesType.map((val, idx) => {
                arry.push(
                    <li key={idx}>
                        <label className="chkContainer"> {val}
                            <input type="checkbox"
                                value={val}
                                onChange={handleAmenitiesTypeCheckboxChange}
                                checked={amenitiesArray.includes(val)}
                            />
                            <span className="checkmark"></span>
                        </label>
                    </li>
                )
            })
        }
        return arry;
    }

    //aminity onchange event
    const handleAmenitiesTypeCheckboxChange = (event) => {
        const { value, checked } = event.target;
        debounceDispatchAmenitiesTypeList(value, checked);
    };

    //set filter data after amenity change
    const debounceDispatchAmenitiesTypeList = Utility.debounce((value, checked) => {
        setFilterPanelData({
            ...filterPanelData,
            // Explicitly preserve property_type to prevent it from being reset
            property_type: filterPanelData.property_type,
            // Preserve other values
            property_rating: filterPanelData.property_rating,
            meals: filterPanelData.meals,
            // Update amenities value
            amenities: checked
                ? [...filterPanelData.amenities, value]
                : filterPanelData.amenities.filter((item) => item !== value)
        });
        setIsFilterDataChanged(true)
    }, 300);

    //meal list ui
    const mealListUi = () => {
        // Use local filterPanelData state instead of Redux state for UI
        const mealsArray = Array.isArray(filterPanelData.meals) ? 
            filterPanelData.meals : 
            (filterPanelData.meals ? [filterPanelData.meals] : []);
            
        let arry = [];
        if (mealList.length > 0) {
            mealList.map((val, idx) => {
                arry.push(
                    <li key={idx}>
                        <label className="chkContainer"> {val}
                            <input type="checkbox"
                                value={val}
                                onChange={mealListCheckboxChange}
                                checked={mealsArray.includes(val)}
                            />
                            <span className="checkmark"></span>
                        </label>
                    </li>
                )
            })
        }
        return arry;
    }

    //meal onchange event
    const mealListCheckboxChange = (event) => {
        const { value, checked } = event.target;
        debounceDispatchMealList(value, checked);
    };

    //set filter panel data after meal change
    const debounceDispatchMealList = Utility.debounce((value, checked) => {
        setFilterPanelData({
            ...filterPanelData,
            // Explicitly preserve property_type to prevent it from being reset
            property_type: filterPanelData.property_type,
            // Preserve other values
            property_rating: filterPanelData.property_rating,
            amenities: filterPanelData.amenities,
            // Update meals value
            meals: checked
                ? [...filterPanelData.meals, value]
                : filterPanelData.meals.filter((item) => item !== value)
        });
        setIsFilterDataChanged(true)
    }, 300);


    useEffect(() => {
        if (isFilterDataChanged) {
            setIsFilterDataChanged(false);
        }
    }, [isFilterDataChanged]);

    // Function for the new Apply Filter button at the top
    const applyFilters = () => {
        // Call the same function that the bottom Apply Filters button calls
        dispatchFilterData();
    };

    // Store current filter data but don't automatically dispatch
    const lastFilterData = useRef(null);
    
    // Instead of automatically dispatching on filter changes, just update the parent component
    useEffect(() => {
        if (filterPanelData) {
            // Store the current filter data for use when search button is clicked
            lastFilterData.current = { ...filterPanelData };
            
            // Log filter changes but don't dispatch automatically
            // console.log('Filter data updated locally (waiting for search button):', 
            //           JSON.stringify(filterPanelData).substring(0, 100));
            
            // Always send to parent component to update UI
            props.sendDataToParent(filterPanelData);
        }
    }, [filterPanelData]);
    
    // Function to manually dispatch filter changes when search button is clicked
    const dispatchFilterData = () => {
        if (lastFilterData.current) {
            // Get the existing search data from Redux
            let reducerData = props.userSearchDataFromReducer || {};
            
            // Create new search data with updated filter
            let tempSearchData = { ...reducerData, filterData: lastFilterData.current };
            
            // Log manual dispatch
            // console.log('FilterPanel manually dispatching with filter:', 
            //           JSON.stringify(lastFilterData.current).substring(0, 100));
            
            // Dispatch to Redux
            props.userSearchData(tempSearchData);
            
            // Call search function directly if available
            if (props.searchHotelBranch && typeof props.searchHotelBranch === 'function') {
                props.searchHotelBranch();
            }
        }
    };

    //budget onchange event
    const handleSliderChange = (newValue) => {
        const newMin = Math.max(budgetRange.min, newValue.min); // Ensure minimum doesn't go below budgetRange.min
        const newMax = Math.min(budgetRange.max, newValue.max);
        if (newValue.max <= budgetRange.max) {
            setBudgetValue({ min: newMin, max: newMax })
            setIsFilterDataChanged(true);
        }
    };

    const handleSliderFinalChange = (newValue) => {
        setFilterPanelData({ ...filterPanelData, budget_min: newValue.min, budget_max: newValue.max });
        setIsFilterDataChanged(true);
    };


    return (
        <>
            {apiCallFilterFinish ?
            <div className={` ${props.leftSearchFlag + ' ' + "col-xl-3 col-lg-3 col-md-4 col-sm-4 pushMenu"}`}>
                <div className='searchLeft'>
                    <button onClick={() => { props.crossFN() }} className='crossBtn'>✖</button>
                    <div className={`innsearchLeftBox ${isViewportBottom ? 'is-sticky' : ''}`}>

                        <div className="filter-header" style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center',
                            marginBottom: '15px',
                            background: '#f1f1f1',
                            borderBottom: '1px solid #dddddd'
                        }}>
                            <h6 style={{ margin: 0 }}>Filter by</h6>
                            <button 
                                className="apply-filter-btn" 
                                onClick={dispatchFilterData}
                                style={{ 
                                        background: '#323232',
                                        padding: '5px 10px',
                                        border: 'none',
                                        color: '#e9c905',
                                        borderRadius: '3px',
                                        marginRight: '5px',
                                        fontSize: '12px'
                                    }}
                            >Apply Filter</button>
                        </div>
                        <div className='innfilterBoxes'>
                            <div className='filterBox'>
                                <strong>Your budget (per night)</strong>
                                <InputRange
                                    minValue={budgetRange.min}
                                    maxValue={budgetRange.max}
                                    value={budgetValue}
                                    onChange={handleSliderChange}
                                    onChangeComplete={handleSliderFinalChange}
                                />
                            </div>
                            <div className='filterBox'>
                                <strong>Property type</strong>
                                <ul key={'property_type'}>
                                    {propertyTypeUi()}

                                </ul>

                            </div>
                            {shouldShowPropertyRating() &&
                                <div className='filterBox'>
                                    <strong>Property rating</strong>
                                    <ul key={'property_rating'}>
                                        {propertyRatingUi()}
                                    </ul>
                                </div>
                            }
                            <div className='filterBox'>
                                <strong>Property amenities</strong>
                                <ul key={'property_amenities'}>
                                    {amenitiesTypeUi()}
                                </ul>
                            </div>
                            {/* <div className='filterBox'>
                                <strong>Meals</strong>
                                <ul key={'meal_list'}>
                                    {mealListUi()}
                                </ul>
                            </div> */}
                            
                            {/* Add Apply Filters button */}
                            <div className='filterBox' style={{ textAlign: 'center' }}>
                                <button 
                                    onClick={dispatchFilterData} 
                                    className='btn btn-primary btn-block'
                                    style={{ 
                                        background: '#323232',
                                        padding: '5px 10px',
                                        border: 'none',
                                        color: '#e9c905',
                                        borderRadius: '3px',
                                        fontSize: '12px'
                                    }}
                                >
                                    Apply Filters
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
                     :
                <SkeletonThemeFilterContent />}
        </>
    );
}

FilterPanel.defaultProps = {

}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        userSearchDataFromReducer: globalState.mainReducerData.userSearchData
    };
}


export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setUserCredentials, logOutApp, roleWisePermission, userSearchData, setToken, })(FilterPanel);
